import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

const PAGE_NAME = "ResponseAttachmentModal.js_";

const ResponseAttachmentModal = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [selectedData, setSelectedData] = useState([]);

  // const attachmentId = props.attachmentData.ATTACHMENT_ID;

  // useEffect(() => {
  //   let functionName = "";

  //   try {
  //     functionName = "Get Ticket Response Attachment";

  //     onLoadingHandler(
  //       true,
  //       "Getting ticket response attachment, please wait..."
  //     );

  //     setAttachmentList([]);

  //     const listItems = [];

  //     http
  //       .get(
  //         `api/response/GetAttachment?_attachmentId=${attachmentId}&_user=${userId}`,
  //         { timeout: 100000 }
  //       )
  //       .then((response) => {
  //         if (response.data.length > 0) {
  //           response.data.forEach((_data) => {
  //             listItems.push({
  //               ATTACHMENT_ID: _data.ATTACHMENT_ID,
  //               ATTACHMENT_NAME: _data.ATTACHMENT_NAME,
  //               ATTACHMENT_PATH: _data.ATTACHMENT_PATH,
  //             });
  //           });
  //           setAttachmentList(listItems[0]);
  //         }
  //       })
  //       .catch((err) => {
  //         toast.error("Error on getting attachment. Please try again.");
  //         common.c_LogWebError(PAGE_NAME, functionName, err);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //         setLoadingText("Loading...");
  //       });
  //   } catch (err) {
  //     toast.error("Error on getting attachment. Please try again.");
  //     common.c_LogWebError(PAGE_NAME, functionName, err);
  //   }
  // }, [userId]);

  // console.log(attachmentList);

  const data = props.responseAttachment;

  function getSelectedData(dataSelected) {
    let promise = common.c_getTableSelectedData(data, dataSelected);
    promise.then((result) => {
      // console.log(dataSelected);
      setSelectedData(result);
    });
  }

  const columns = [
    {
      accessorKey: "ATTACHMENT_NAME",
      header: "File",
    },
  ];

  const hideModal = () => {
    props.onHide();
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  // const attachmentId = props.attachmentList[0].ATTACHMENT_ID;
  // console.log(attachmentId);

  const downloadFileHandler = () => {
    if (Object.keys(selectedData) === 0) {
      toast.error("Please select file to download.");
    } else {
      var attachmentId = [];
      for (const key in selectedData) {
        attachmentId.push(selectedData[key].ATTACHMENT_ID);
      }
      window.open(
        common.c_getApiUrl() +
          `api/response/ExportAttachment?_user=${userId}&_attachmentId=${attachmentId}`,
        { timeout: 100000 }
      );
      hideModal();
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header style={{ textAlign: "center" }}>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>UPLOADED FILE</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Table
            columns={columns}
            data={props.responseAttachment}
            enableRowSelection={true}
            getSelectedData={getSelectedData}
            enableStickyHeader
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button
              id="btnDownload"
              type="download"
              onClick={downloadFileHandler}
            >
              Download
            </Comp.Button>
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResponseAttachmentModal;
